@if (ehr()?.errors?.length) {
  <div class="flex flex-col gap-2 mb-4">
    @for (error of ehr().errors; track error.id) {
      <nz-alert nzType="warning" [nzMessage]="error.Description" nzShowIcon></nz-alert>
    }
  </div>
}

<nz-spin nzTip="Loading..." [nzSpinning]="ehrLoading()">
  @if (!isTemplateMode()) {
    <div class="grid grid-cols-2 gap-4">
      <div class="mb-4 border-b-2 border-gray-200 ">
        ანკეტის ნომერი: <span class="font-bold ">{{ ehr()?.ehrNo }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        თარიღი: <span class="font-bold ">{{ ehr()?.visitDate }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        EHR Id: <span class="font-bold ">{{ ehr()?.ehrId }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        სტატუს: <span class="font-bold ">{{ ehr()?.status }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        მომხმარებელი: <span class="font-bold ">{{ ehr()?.user?.firstName }} {{ ehr()?.user?.lastName }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        პირადი ნომერი: <span class="font-bold ">{{ ehr()?.user?.idNumber }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        თანამშრომელი: <span class="font-bold ">{{ ehr()?.employee?.firstName }} {{ ehr()?.employee?.lastName }}</span>
      </div>
      <div class="mb-4 border-b-2 border-gray-200 ">
        სპეციალობა: <span class="font-bold ">{{ medicalSpeciality(ehr()?.employee?.medicalSpecialtyId) }}</span>
      </div>

    </div>
  }

  <form [formGroup]="form" nz-form nzLayout="horizontal">
    <nz-collapse [nzBordered]="false" [style]="{
      'border': 'none',
      'background': 'transparent',
      'margin-top': '20px'
    }">


      <nz-collapse-panel [style]="customStyle" nzHeader="ჩივილები">
        <div>
          <div nz-row [nzGutter]='24'>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="advice">ჰოსპიტალიზაციის მიზეზი</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="typeOfHospitalization" nzSize="large">
                    @for (treatment of treatmentTypes; track treatment.value) {
                      <nz-option [nzLabel]="treatment.alias" [nzValue]="treatment.value"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="advice">ჩივილები</nz-form-label>
            <nz-form-control>
              <textarea nz-input formControlName="simptoms"></textarea>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="advice">დაავადების ანამნეზი</nz-form-label>
            <nz-form-control>
              <textarea nz-input formControlName="diseaseAnamnesis"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-collapse-panel>
      <nz-collapse-panel [style]="customStyle" nzHeader="ობიექტური გამოკვლევები">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="advice">ობიექტური გამოკვლევები</nz-form-label>
          <nz-form-control>
            <textarea nz-input formControlName="objectiveExaminations"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzSpan="24">
            გამოკვლევის სახე
          </nz-form-label>
          <nz-form-control>
            <nz-select formControlName="questionnaireBuilderId" nzSize="large">
              @for (questionnaire of questionnaires(); track questionnaire.value) {
                <nz-option [nzLabel]="questionnaire.label" [nzValue]="questionnaire.value"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <div formGroupName="questionnaires">
          @for (field of questionnairesFields(); track field) {
            <nz-form-item>
              <nz-form-label nzSpan="24" [nzFor]="field.name" [nzRequired]="field.required">{{ field.label }}
              </nz-form-label>
              <nz-form-control [nzErrorTip]="'This field is required'">
                <!-- Text Input -->
                @if (field.type === 'text') {
                  <input nz-input [formControlName]="field.name" [id]="field.name"
                    nzSize="large" />
                }
                <!-- Textarea -->
                @if (field.type === 'textarea') {
                  <textarea
                    nz-input
                    [formControlName]="field.name"
                    [id]="field.name"
                    rows="4"
                    nzSize="large"
                  ></textarea>
                }
                <!-- Select -->
                @if (field.type === 'select') {
                  <nz-select
                    [formControlName]="field.name"
                    [nzId]="field.name"
                    [nzMode]="field.multiple ? 'multiple' : 'default'"
                    nzAllowClear
                    nzSize="large"
                    >
                    @for (opt of field.options; track opt) {
                      <nz-option [nzValue]="opt.value"
                      [nzLabel]="opt.label"></nz-option>
                    }
                  </nz-select>
                }
                @if (field.type === 'checkbox') {
                  @if (field.options.length && field.multiple) {
                    <nz-checkbox-group [formControlName]="field.name">
                      @for (opt of field.options; track opt) {
                        <label nz-checkbox [nzValue]="opt.value">
                          {{ opt.label }}
                        </label>
                      }
                    </nz-checkbox-group>
                  } @else {
                    <label nz-checkbox [formControlName]="field.name">
                      {{ field.label }}
                    </label>
                  }
                }
              </nz-form-control>
            </nz-form-item>
          }
          <!--        <nz-form-item>-->
          <!--          <nz-form-label nzSpan="24" nzFor="advice">გამოკვლევის შედეგი</nz-form-label>-->
          <!--          <nz-form-control>-->
          <!--            <textarea nz-input formControlName="advice"></textarea>-->
        <!--          </nz-form-control>-->
      <!--        </nz-form-item>-->
    </div>
  </nz-collapse-panel>
  @if (!isTemplateMode()) {
    <nz-collapse-panel [style]="customStyle" nzHeader="პაციენტის ანამნეზი">
      @if (ehr()?.userId) {
        <beautyapp-patient-anamnesis [parentForm]="form" [userId]="ehr()?.userId" />
      }
    </nz-collapse-panel>
  }
  <nz-collapse-panel [style]="customStyle" nzHeader="მკურნალობის პროცესი">
    <button nz-button nzType="primary" class="mt-2" (click)="createTreatment(ehr().id)">+ დამატება</button>

    <div>
      @if (clinicalDiagnosis().length) {
        <div>
          <ng-template #ClinicalDiagnosticExplorationTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">კლინიკურ დიაგნოსტიკური კვლევები</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="ClinicalDiagnosticExplorationTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>ICD10</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (clinicalDiagnos of clinicalDiagnosis(); track clinicalDiagnos.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="clinicalDiagnos.ncsp?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ clinicalDiagnos.ncsp?.code }}</span>
                  </td>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="clinicalDiagnos.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ clinicalDiagnos.icd10?.code }}</span>
                  </td>
                  <td>{{ clinicalDiagnos.procedureResult }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('CLINICAL_DIAGNOSTIC', ehr().id, clinicalDiagnos)">
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(clinicalDiagnos.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }

            </tbody>
          </nz-table>


        </div>
      }
      @if (otherActivities().length) {
        <div>
          <ng-template #OtherActivityTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">თანმხლები აქტივობა</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="OtherActivityTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>ICD10</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (otherActivity of otherActivities(); track otherActivity.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="otherActivity.ncsp?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ otherActivity.ncsp?.code }}</span>
                  </td>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="otherActivity.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ otherActivity.icd10?.code }}</span>
                  </td>
                  <td>{{ otherActivity.procedureResult }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('OTHER_ACTIVITY', ehr().id, otherActivity)">
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(otherActivity.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (labTests().length) {
        <div>
          <ng-template #LabTestTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ლაბორატორიული გამოკვლევები</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="LabTestTitle">
            <thead>
              <tr>
                <th>ლაბორატორია</th>
                <th>ლაბორატორიული კვლევის ტექსტი</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (labTest of labTests(); track labTest.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="labTest.labCode?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ labTest.labCode?.code }}</span>
                  </td>
                  <td>{{ labTest.labExamText }}</td>
                  <td>{{ labTest.procedureResult }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('LAB_TEST', ehr().id, labTest)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(labTest.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }

      @if (consultations().length) {
        <div>
          <ng-template #ConsultationsTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">კონსულტაციები</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="ConsultationsTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>ICD10</th>
                <th>ექიმის სპეციალობა</th>
                <th>ექიმი</th>
                <th>თარიღი</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (consultation of consultations(); track consultation.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="consultation.ncsp?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ consultation.ncsp?.code }}</span>
                  </td>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="consultation.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ consultation.icd10?.code }}</span>
                  </td>
                  <td>{{ consultation.codeOfTheMedicalSpecialty }}</td>
                  <td>{{ consultation.consultantDoctorName }}</td>
                  <td>{{ consultation.consultationDate }}</td>
                  <td>{{ consultation.consultationResultsComment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('CONSULTATION', ehr().id, consultation)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(consultation.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (prescriptions().length) {
        <div>
          <ng-template #PrescriptionTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">დანიშნულება</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="PrescriptionTitle">
            <thead>
              <tr>
                <th>ICD10</th>
                <th>drugID</th>
                <th>მედიკამენტი</th>
                <th></th>
                <th>რაოდენობა</th>
                <th>დანიშნულება</th>
                <th>გამოყენება</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (prescription of prescriptions(); track prescription.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="prescription.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ prescription.icd10?.code }}</span>
                  </td>
                  <td>{{ prescription.drug?.productId }}</td>
                  <td>{{ prescription.drugName }}</td>
                  <td>{{ prescription.linked }}</td>
                  <td>{{ prescription.drugCount }}</td>
                  <td>{{ prescription.ds }}</td>
                  <td>{{ prescription.wasUsed }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('PRESCRIPTION', ehr().id, prescription)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(prescription.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (anesthesias().length) {
        <div>
          <ng-template #AnesthesiaTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ანესთეზიის ეპიზოდი</h4>
              <button nz-button nzShape="circle" class="mt-2">
                <i nz-icon nzType="plus"></i>
              </button>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="AnesthesiaTitle">
            <thead>
              <tr>
                <th>ICD10</th>
                <th>NCSP</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (anesthesia of anesthesias(); track anesthesia.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="anesthesia.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ anesthesia.icd10?.code }}</span>
                  </td>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="anesthesia.ncsp?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500">
                      {{ anesthesia.ncsp?.code }}
                    </span>
                  </td>
                  <td>{{ anesthesia.anesthesiaComment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('ANESTHESIA', ehr().id, anesthesia)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(anesthesia.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (transfusions().length) {
        <div>
          <ng-template #transfusionsTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">სისხლის გადასხმა</h4>
              <button nz-button nzShape="circle" class="mt-2">
                <i nz-icon nzType="plus"></i>
              </button>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="transfusionsTitle">
            <thead>
              <tr>
                <th>სისხლის კომპონენტი</th>
                <th>ტრანსფუზიის ჩვენება</th>
                <th>რაოდენობა</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (transfusion of transfusions(); track transfusion.id) {
                <tr>

                  <td>{{ transfusion.bloodComponent | bloodComponent }}</td>
                  <td>{{ transfusion.indicationOfTransfusion }}</td>
                  <td>{{ transfusion.quantity }}</td>
                  <td>{{ transfusion.transfusionComment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('TRANSFUSION', ehr().id, transfusion)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(transfusion.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (surgeries().length) {
        <div>
          <ng-template #SurgicalInterventionTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ქირურგიული ჩარევა</h4>
              <button nz-button nzShape="circle" class="mt-2">
                <i nz-icon nzType="plus"></i>
              </button>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="SurgicalInterventionTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>ICD10</th>
                <th>პროტოკოლის #</th>
                <th>კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (surgery of surgeries(); track surgery.id) {
                <tr>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="surgery.ncsp?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500">
                      {{ surgery.ncsp?.code }}
                    </span>
                  </td>
                  <td>
                    <span nz-tooltip [nzTooltipTitle]="surgery.icd10?.nameGeo"
                      class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
                    >{{ surgery.icd10?.code }}</span>
                  </td>
                  <td>{{ surgery.protocolNo }}</td>
                  <td>{{ surgery.procedureResult }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('SURGERY', ehr().id, surgery)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(surgery.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (operationProtocols().length) {
        <div>
          <ng-template #OperationProtocolTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ოპერაციის ოქმი</h4>
              <button nz-button nzShape="circle" class="mt-2">
                <i nz-icon nzType="plus"></i>
              </button>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="OperationProtocolTitle">
            <thead>
              <tr>
                <th>პროტოკოლის #</th>
                <th>პროტოკოლი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (operationProtocol of operationProtocols(); track operationProtocol.id) {
                <tr>
                  <td>{{ operationProtocol.protocolNo }}</td>
                  <td>{{ operationProtocol.protocol }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="editTreatment('OPERATION_PROTOCOL', ehr().id, operationProtocol)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteTreatment(operationProtocol.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
    </div>
  </nz-collapse-panel>
  <nz-collapse-panel [style]="customStyle" nzHeader="გაწერის შემდგომი რეკომენდაციები">
    <div>
      <button nz-button nzType="primary" class="mt-2" (click)="createRecommendation(ehr().id)">+ დამატება
      </button>

      @if (recommendationOther().length) {
        <div>
          <ng-template #RecommendationLabTestTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">
                რჩევა/დარიგება
              </h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="RecommendationLabTestTitle">
            <thead>
              <tr>
                <th>რჩევა/დარიგება</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (recommendation of recommendationOther(); track recommendation.id) {
                <tr>
                  <td>{{ recommendation.recommendation }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="createRecommendation(ehr().id,recommendation)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <ng-container *nzSpaceItem>
                        <button nz-button nzDanger
                          nz-popconfirm
                          nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                          nzPopconfirmPlacement="bottom"
                          (nzOnConfirm)="deleteRecomendation(recommendation.id)"
                          >
                          <i nz-icon nzType="delete"></i>
                        </button>
                      </ng-container>
                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
      @if (recomendedSurgicalIntervention().length) {
        <div>
          <ng-template #RecomendedSurgicalInterventionTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ქირურგიული ჩარევები/პროცედურები</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="RecomendedSurgicalInterventionTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>NCSP კომენტარი</th>
                <th>ICD10</th>
                <th>ICD10 კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (recomendedSurgical of recomendedSurgicalIntervention(); track recomendedSurgical.id) {
                <tr>
                  <td>{{ recomendedSurgical.ncsp?.code }}</td>
                  <td>{{ recomendedSurgical.ncspComment }}</td>
                  <td>{{ recomendedSurgical.icd10?.code }}</td>
                  <td>{{ recomendedSurgical.icd10Comment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="createRecommendation(ehr().id,recomendedSurgical)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <ng-container *nzSpaceItem>
                        <button nz-button nzDanger
                          nz-popconfirm
                          nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                          nzPopconfirmPlacement="bottom"
                          (nzOnConfirm)="deleteRecomendation(recomendedSurgical.id)"
                          >
                          <i nz-icon nzType="delete"></i>
                        </button>
                      </ng-container>
                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }

      @if (instrumentalExplorations().length) {
        <div>
          <ng-template #InstrumentalExplorationsTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">ინსტრუმენტული გამოკვლევები</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="InstrumentalExplorationsTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>კვლევის თარიღი</th>
                <th>ექიმის კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (instrumentalExploration of instrumentalExplorations(); track instrumentalExploration.id) {
                <tr>
                  <td>{{ instrumentalExploration.ncsp?.code }}</td>
                  <td>{{ instrumentalExploration.instrumentalExplorationsDate }}</td>
                  <td>{{ instrumentalExploration.doctorComment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="createRecommendation(ehr().id,instrumentalExploration)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteRecomendation(instrumentalExploration.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }

      @if (consultationsInAmbulatories().length) {
        <div>
          <ng-template #consultationsInAmbulatoriesTitle>
            <div class="flex justify-between items-center">
              <h4 class="text-lg font-semibold mb-4">კონსულტაციები ამბულატორიაში</h4>
            </div>
          </ng-template>
          <nz-table nzTemplateMode [nzTitle]="consultationsInAmbulatoriesTitle">
            <thead>
              <tr>
                <th>NCSP</th>
                <th>სამედიცინო სპეციალობა</th>
                <th>ვადა</th>
                <th>ექიმის კომენტარი</th>
                <th nzWidth="100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (
                consultationsInAmbulatory of consultationsInAmbulatories(); track consultationsInAmbulatory.id) {
                <tr>
                  <td>{{ consultationsInAmbulatory.ncsp?.code }}</td>
                  <td>{{ classificationCodeService.medicalSpeciality(consultationsInAmbulatory.specialtyCode) }}</td>
                  <td>{{ consultationsInAmbulatory.deadline }}</td>
                  <td>{{ consultationsInAmbulatory.doctorComment }}</td>
                  <td>
                    <nz-space>
                      <button *nzSpaceItem nz-button nzType="primary"
                        (click)="createRecommendation(ehr().id,consultationsInAmbulatory)"
                        >
                        <i nz-icon nzType="edit"></i>
                      </button>
                      <button *nzSpaceItem nz-button nzDanger
                        nz-popconfirm
                        nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteRecomendation(consultationsInAmbulatory.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>

                    </nz-space>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>


        </div>
      }
    </div>
  </nz-collapse-panel>
  <nz-collapse-panel [style]="customStyle" nzHeader="მედიკამენტური დანიშნულება">
    <ng-template #erxHeader>
      <div class="flex justify-between items-center">
        <div>მედიკამენტები</div>
        <button nz-button nzType="primary" nzSize="small"
          (click)="addEditDrug()"
          >
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
    </ng-template>
    <nz-table nzTemplateMode [nzBordered]="true" [nzTitle]="erxHeader">
      <thead>
        <tr>
          <th>მედიკამენტის კოდი</th>
          <th>მედიკამენტი</th>
          <th>გენერიკი</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (prescription of erxPrescriptions(); track prescription.id) {
          <tr>
            <td>{{ prescription.product.productId }}</td>
            <td>{{ prescription.product.geoTradeName }}</td>
            <td>{{ prescription.product.productGeneric }}</td>
            <td>
              <nz-space>
                <button *nzSpaceItem nz-button nzType="primary"
                  (click)="addEditDrug(prescription)"
                  nzShape="circle"
                  >
                  <i nz-icon nzType="edit"></i>
                </button>
                <button
                  *nzSpaceItem
                  nz-button
                  nzDanger
                  nz-popconfirm
                  nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="deleteDrug(prescription.id)"
                  >
                  <i nz-icon nzType="delete"></i>
                </button>
              </nz-space>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </nz-collapse-panel>
  @if (visits().length) {
    <nz-collapse-panel [style]="customStyle" nzHeader="განხორციელებული ვიზიტები">
      <div>
        <nz-table nzTemplateMode [nzBordered]="true">
          <thead>
            <tr>
              <th>დაწყება</th>
              <th>დასრულება</th>
              <th>კომენტარი</th>
            </tr>
          </thead>
          <tbody>
            @for (visit of visits(); track visit.id) {
              <tr>
                <td>{{ visit.visitStartDate | date:'dd MMM yyyy HH:mm' }}</td>
                <td>{{ visit.visitEndDate | date:'dd MMM yyyy HH:mm' }}</td>
                <td>{{ visit.visitComment }}</td>
              </tr>
            }
          </tbody>
        </nz-table>
      </div>
    </nz-collapse-panel>
  }

  <nz-collapse-panel [style]="customStyle" [nzActive]="true" nzHeader="დასკვნითი დიაგნოზი">
    <div class="flex flex-col gap-4" >
      <div>
        <div class="flex flex-col gap-4">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="result" nzRequired>ძირითადი დაავადება</nz-form-label>
            <nz-form-control>
              <nz-tree-select
                formControlName="icd10Id"
                [nzNodes]="classificationCodeService.classificationICDCodes()"
                nzShowSearch
                nzPlaceHolder="Please select"
                nzVirtualHeight="300px"
                nzHideUnMatched="true"
                nzCheckStrictly="true"
                nzShowLine="true"
                nzSize="large"
              ></nz-tree-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="result">ძირითადი დაავადება(დაზუსტება)</nz-form-label>
            <nz-form-control>
              <nz-tree-select
                formControlName="icd102Id"
                [nzNodes]="classificationCodeService.classificationICDCodes()"
                nzShowSearch
                nzPlaceHolder="Please select"
                nzVirtualHeight="300px"
                nzHideUnMatched="true"
                nzCheckStrictly="true"
                nzShowLine="true"
                nzSize="large"
              ></nz-tree-select>
            </nz-form-control>
          </nz-form-item>

          <nz-radio-group formControlName="illness">
            @for (illnessType of illnessTypes(); track illnessType) {
              <label nz-radio [nzValue]="illnessType.id"
              class="input-label">{{ illnessType.value }}</label>
            }
          </nz-radio-group>
        </div>
      </div>
      <div formArrayName="diseaseComplications">
        <div class="flex gap-4 items-center border-t border-gray-200 pt-2">
          <div class="text-lg font-semibold">
            დაავადების გართულება
          </div>
          <div>
            <button nz-button nzType="primary" nzSize="small"
              (click)="addDiseaseComplications()"
              >
              <i nz-icon nzType="plus" nzTheme="outline"></i>
            </button>
          </div>
        </div>
        @for (disease of diseaseComplications.controls; track disease; let i = $index) {
          <div class="flex flex-col gap-4 border-b border-dashed pb-4" [formGroupName]="i">
            <nz-form-item>
              <nz-form-label nzSpan="24" nzFor="result" nzRequired>ICD-10</nz-form-label>
              <nz-form-control>
                <nz-tree-select
                  formControlName="icd10Id"
                  [nzNodes]="classificationCodeService.classificationICDCodes()"
                  nzShowSearch
                  nzPlaceHolder="Please select"
                  nzVirtualHeight="300px"
                  nzHideUnMatched="true"
                  nzCheckStrictly="true"
                  nzShowLine="true"
                  nzSize="large"
                ></nz-tree-select>
              </nz-form-control>
            </nz-form-item>

            <div class="flex justify-between items-center">
              <div>
                <nz-radio-group formControlName="illness">
                  @for (illnessType of illnessTypes(); track illnessType) {
                    <label nz-radio [nzValue]="illnessType.id"
                    class="input-label">{{ illnessType.value }}</label>
                  }
                </nz-radio-group>
              </div>
              <div>
                <button nz-button nzType="primary" nzDanger nzSize="small"
                  (click)="removeDiseaseComplications(i)"
                  >
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      <div formArrayName="accompanyingDisease">
        <div class="flex gap-4 items-center border-t border-gray-200 pt-2">
          <div class="text-lg font-semibold">
            თანმხლები დაავადება
          </div>
          <div>
            <button nz-button nzType="primary" nzSize="small"
              (click)="addAccompanyingDisease()"
              >
              <i nz-icon nzType="plus" nzTheme="outline"></i>
            </button>
          </div>
        </div>
        @for (disease of accompanyingDiseaseForm.controls; track disease; let i = $index) {
          <div class="flex flex-col gap-4 border-b border-dashed pb-4" [formGroupName]="i">
            <nz-form-item>
              <nz-form-label nzSpan="24" nzFor="result" nzRequired>ძირითადი(ICD-10)</nz-form-label>
              <nz-form-control>
                <nz-tree-select
                  formControlName="icd10Id"
                  [nzNodes]="classificationCodeService.classificationICDCodes()"
                  nzShowSearch
                  nzPlaceHolder="Please select"
                  nzVirtualHeight="300px"
                  nzHideUnMatched="true"
                  nzCheckStrictly="true"
                  nzShowLine="true"
                  nzSize="large"
                ></nz-tree-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzSpan="24" nzFor="result" nzRequired>დაზუსტება(ICD-10)</nz-form-label>
              <nz-form-control>
                <nz-tree-select
                  formControlName="icd102Id"
                  [nzNodes]="classificationCodeService.classificationICDCodes()"
                  nzShowSearch
                  nzPlaceHolder="Please select"
                  nzVirtualHeight="300px"
                  nzHideUnMatched="true"
                  nzCheckStrictly="true"
                  nzShowLine="true"
                  nzSize="large"
                ></nz-tree-select>
              </nz-form-control>
            </nz-form-item>

            <div class="flex justify-between items-center">
              <div>
                <nz-radio-group formControlName="illness">
                  @for (illnessType of illnessTypes(); track illnessType) {
                    <label nz-radio [nzValue]="illnessType.id"
                    class="input-label">{{ illnessType.value }}</label>
                  }
                </nz-radio-group>
              </div>
              <div>
                <button nz-button nzType="primary" nzDanger nzSize="small"
                  (click)="removeAccompanyingDisease(i)"
                  >
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </nz-collapse-panel>
</nz-collapse>
<nz-divider />

<div class="text-right mt-4 flex gap-4 justify-between">
  <button nz-button nzType="default" nzSize="large" (click)="drawerRef.close()">
    <i nz-icon nzType="close" nzTheme="outline"></i>
    დახურვა
  </button>

  <nz-space>
    @if (isTemplateMode()) {
      <button
        *nzSpaceItem
        nz-button nzType="primary" nzSize="large"
        (click)="saveTemplate()"
        [nzLoading]="submitLoading()"
        >
        <i nz-icon nzType="save" nzTheme="outline"></i>
        {{ data().mode === 'create' ? 'შექმნა' : 'შენახვა' }}
      </button>
    } @else {
      <button
        *nzSpaceItem
        nz-button nzType="default" nzSize="large"
        (click)="saveEhr(ehr().id)"
        [nzLoading]="submitLoading()"
        >
        <i nz-icon nzType="save" nzTheme="outline"></i>
        შენახვა
      </button>
      <button *nzSpaceItem nz-button nzType="primary" nzSize="large" [disabled]="form.invalid"
        [nzLoading]="submitLoading()"
        (click)="sendToEhr(ehr().id)">
        <i nz-icon nzType="send" nzTheme="outline"></i>
        გაგზავნა
      </button>
      <button *nzSpaceItem nz-button nzType="default" nzSize="large" (click)="download(ehr())">
        <i nz-icon nzType="printer" nzTheme="outline"></i>
        ბეჭდვა
      </button>
    }
  </nz-space>
</div>

</form>

</nz-spin>
